import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcFabrics = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M6.494 15.95 3.16 17.284a.5.5 0 0 0 0 .928l8.282 3.313a1.5 1.5 0 0 0 1.114 0l8.283-3.313a.5.5 0 0 0 0-.928l-3.335-1.334-4.205 1.682a3.5 3.5 0 0 1-2.6 0L6.495 15.95Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M6.494 10.202 3.16 11.536a.5.5 0 0 0 0 .928l8.282 3.313a1.5 1.5 0 0 0 1.114 0l8.283-3.313a.5.5 0 0 0 0-.928l-3.335-1.334-4.205 1.682a3.5 3.5 0 0 1-2.6 0l-4.205-1.682Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M11.442 2.473a1.5 1.5 0 0 1 1.114 0l8.283 3.312a.5.5 0 0 1 0 .929l-8.282 3.313a1.5 1.5 0 0 1-1.115 0L3.16 6.714a.5.5 0 0 1 0-.929l8.282-3.312Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcFabrics");

export { IcFabrics };
//# sourceMappingURL=ic-fabrics.js.map
